import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Inject,
  ViewChild,
  ElementRef
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from "@angular/forms";
import { Distributor } from "../../../models/distributor.model";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatAutocomplete,
  MatAutocompleteTrigger
} from "@angular/material";
import { AppService } from "../../../services/app.service";
import { DistributorService } from "../../../services/distributor.service";
import { MasterService } from "../../../services/master.service";
import { Subject } from "rxjs";
import { AjaxService } from "../../../../../core/services/ajax.service";
import { Http } from "@angular/http";
import {
  takeUntil,
  startWith,
  debounceTime,
  distinctUntilChanged,
  switchMap
} from "rxjs/operators";

@Component({
  selector: "app-distributor-edit-form",
  templateUrl: "./distributor-edit-form.component.html",
  styleUrls: ["./distributor-edit-form.component.scss"]
})
export class DistributorEditFormComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  countryList: any = [];
  countryFilterCtrl: FormControl = new FormControl();
  depotTypeList : any = [];
  /** Subject that emits when the component has been destroyed. */
  private _onDestroy = new Subject<void>();
  searchFlag: boolean = true;
  cityList: any = [];
  cityFilterCtrl: FormControl = new FormControl();
  postalCodeList: any = [];
  psFilterCtrl: FormControl = new FormControl();
  fhMapping: any = [];
  distributorId: Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  distributor = new Distributor();
  loadingIndicator = false;
  reorderable = true;
  translations: any;
  countryLoad = true;
  cityLoad = true;
  loadingCountry = false;
  invalidForm = true;

  countryRequired = false;
  cityRequired = false;
  pcRequired = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { Id: 0 },
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public appService: AppService,
    private distributorService: DistributorService,
    private masterService: MasterService,
    private http: Http,
    private _ajaxService: AjaxService,
    public dialogRef: MatDialogRef<DistributorEditFormComponent>
  ) {
    this.setPageTranslations();
    this.formGroupErrors = {
      Code: {},
      Name: {},
      IsActive: {},
      Email: {},
      Address: {},
      VAT: {},
      IncludeInFinance : {},
      DepotTypeId:{}
    };

    this.formGroup = this.formBuilder.group({
      Code: ["", Validators.required],
      Name: ["", Validators.required],
      IsActive: ["", Validators.required],
      //Email: ["",Validators.pattern(/^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))*$/)],
      // Email: ["", Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)],
      //Email: ["", Validators.pattern(/^([\w-\.]{1,64}((\[|\()?@(\]|\))?|(\[|\()?at(\]|\))?|(\[|\()?kukac(\]|\))?)[\w-]{1,64}((\[|\()?\.(\]|\))?|(\[|\()?dot(\]|\))?|(\[|\()?pont(\]|\))?)[a-zA-Z]{2,3})$/)],
      Email: ['', [Validators.pattern(/^([\w+-.%]+@[\w\-.]+\.[A-Za-z]{2,4};?)+$/)]],
      Address: ["", Validators.required],
      VAT: ["", Validators.required],
      IncludeInFinance: ["", Validators.required],
      DepotTypeId :["",Validators.required]
    });
    this.distributorId = this.data.Id;
  }
  onCountryBlur(e){
    this.countryRequired = this.distributor.CountryId > 0 ? false : true;
  }
  onCityBlur(e){
    this.cityRequired = this.distributor.CityId > 0 ? false : true;
  }
  onPCBlur(e){
    this.pcRequired = this.distributor.PostalCodeId > 0 ? false : true;
  }
  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }

  ngOnInit() {
    this.countryLoad = true;
    this.cityLoad = true;
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(      
        this.formGroup,
        this.formGroupErrors
      );
     if(this.distributor.CountryId > 0
      && this.distributor.CityId > 0
      && this.distributor.PostalCodeId > 0
      && !this.formGroup.invalid){
        this.invalidForm = false;
      }
      else{
        this.invalidForm = true;
      }
      
    });
   
    if (this.distributorId > 0) {
      this.selectDistributorById();
    }
    else{
      this.appService.hideLoading();
      this.invalidForm = true;
    }
    this.masterService
    .selectSysData("DepotType",this.distributor.DepotTypeId)
    .subscribe(
    res => this.getDepotTypeSuccess(res),
    error => this.apiFaillure(error)
    );
    this.countryFilterCtrl.valueChanges
      .debounceTime(400)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCountry();
      });
    this.cityFilterCtrl.valueChanges
      .debounceTime(400)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCity();
      });
    this.psFilterCtrl.valueChanges
      .debounceTime(400)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterPostalCode();
      });
  }

  selectDistributorById(): void {
    this.distributorService
      .select(this.distributorId)
      .subscribe(
        res => this.getDistributorDetailsSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  getDistributorDetailsSuccess(res): void {
    if (res.Data != null) {
      this.distributor = JSON.parse(res.Data)[0];
      this.countryFilterCtrl.setValue(this.distributor["Country"]);
      this.cityFilterCtrl.setValue(this.distributor["City"]);
      this.psFilterCtrl.setValue(this.distributor["PostalCode"]);
      this.invalidForm = false;
      this.appService.hideLoading();
    } else {
      this.apiFaillure(res.Message);
    }
  }

  filterCountry() {
    this.loadingCountry = true;
    let search = this.countryFilterCtrl.value;
    if (search && search.length > 0) {
      this._ajaxService
        .GET(
          "Master.svc/master/31/" +
            (typeof this.distributor.CountryId != "undefined"
              ? this.distributor.CountryId
              : 0) +
            "/0/" +
            (!search ? " " : search) +
            "/0"
        )
        .subscribe(response => {
          this.countryList = JSON.parse(response.Data);
          this.countryRequired = this.distributor.CountryId > 0 ? false : true;
        });
    } else {
      this.distributor.CountryId = 0;
      this.countryList = [];
      this.countryRequired = true;
    }
  }
  onCountrySelect(countryId) {
    if (this.distributor.CountryId != countryId) {
      this.invalidForm = true;
      this.distributor.CountryId = countryId;
      this.countryRequired = this.distributor.CountryId > 0 ? false : true;
      this.distributor.CityId = 0;
      this.cityFilterCtrl.setValue("");
      this.distributor.PostalCodeId = 0;
      this.psFilterCtrl.setValue("");
    }
  }
  onCitySelect(cityId) {
    if (this.distributor.CityId != cityId) {
      this.invalidForm = true;
      this.distributor.CityId = cityId;
      this.cityRequired = this.distributor.CityId > 0 ? false : true;
      this.distributor.PostalCodeId = 0;
      this.psFilterCtrl.setValue("");
    }
  }
  onPCSelect(pcId) {
    if (this.distributor.PostalCodeId != pcId) {
      this.distributor.PostalCodeId = pcId;
      this.pcRequired = this.distributor.PostalCodeId > 0 ? false : true;
      if(this.distributor.CountryId > 0
        && this.distributor.CityId > 0
        && this.distributor.PostalCodeId > 0
        && !this.formGroup.invalid){
          this.invalidForm = false;
        }
        else{
          this.invalidForm = true;
        }
    }
  }
  filterCity() {
    
    let search = this.cityFilterCtrl.value;

    if (
      search &&
      search.length > 0 &&
      typeof this.distributor.CountryId != "undefined" &&
      this.distributor.CountryId > 0
    ) {
      this._ajaxService
        .GET(
          "Master.svc/master/33/" +
            (typeof this.distributor.CityId != "undefined"
              ? this.distributor.CityId
              : 0) +
            "/" +
            (typeof this.distributor.CountryId != "undefined"
              ? this.distributor.CountryId
              : 0) +
            "/" +
            (!search ? " " : search) +
            "/0"
        )
        .subscribe(response => {
          this.cityList = JSON.parse(response.Data);
        });
    } else {
      this.distributor.CityId = 0;
      this.cityList = [];
      this.cityRequired = true;
    }
  }
  filterPostalCode() {
    let search = this.psFilterCtrl.value;

    if (
      search &&
      search.length > 0 &&
      typeof this.distributor.CityId != "undefined" &&
      this.distributor.CityId > 0
    ) {
      this._ajaxService
        .GET(
          "Master.svc/master/34/" +
            (typeof this.distributor.PostalCodeId != "undefined"
              ? this.distributor.PostalCodeId
              : 0) +
            "/" +
            (typeof this.distributor.CityId != "undefined"
              ? this.distributor.CityId
              : 0) +
            "/" +
            (!search ? " " : search) +
            "/0"
        )
        .subscribe(response => {
          this.postalCodeList = JSON.parse(response.Data);
        });
    } else {
      this.distributor.PostalCodeId = 0;
      this.postalCodeList = [];
      this.pcRequired = true;
    }
  }
  apiFaillure(error): void {
    this.appService.showDialogue(
      this.translations.hdError,
      this.translations[error]
    );
  }

  save(): void {
    this.distributorService
      .save(JSON.stringify(this.distributor))
      .subscribe(
        res => this.saveDistributorSuccess(res),
        error => this.apiFaillure(error)
      );
  }
  saveDistributorSuccess(res): void {
    if (res.Status == 1) {
      this.appService
        .showDialogue(
          this.translations.hdSuccess,
          this.translations[res.Message]
        )
        .afterClosed()
        .subscribe(result => {
          if (result) {
            this.close();
          }
        });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }
  close() {
    this.dialogRef.close();
  }

  getDepotTypeSuccess(res){
    if(res.Status == 1){
      this.depotTypeList = JSON.parse(res.Data);
    }
    else{
      this.depotTypeList = [];
    }
  }
  
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor/distributor-edit-form/distributor-edit-form.component.ts